import { default as MuiTableCell, tableCellClasses } from '@mui/material/TableCell';
import { palette } from '@/theme/palette';
import { styled } from '@mui/material/styles';

const TableCell = styled(MuiTableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    backgroundColor: theme?.palette?.neutralGray0?.main ?? palette?.neutralGray0?.main,
    fontWeight: '700',
    height: '48px',
    boxSizing: 'border-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 0,
  },
  [`&.${tableCellClasses.body}`]: {
    borderBottom: 'none',
    borderTop: '1px solid',
    alignItems: 'flex-start',
    height: '48px',
    boxSizing: 'border-box',
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    borderColor: theme?.palette?.neutralGray1?.main ?? palette?.neutralGray1?.main,
    maxWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    lineHeight: '1.25rem',
  },
}));

export default TableCell;
